import {Injectable}  from '@angular/core';
import {HttpService} from '../http.service';
import { Cents }     from '../../../shared/core';
import {Medium}      from '../../../shared-gen/Model/Financial/Medium';
import {Door}        from '../../../shared-gen/Model/Devices/Door';
import {DoorState}   from '../../../shared-gen/Model/Devices/DoorState';
import { TokenSize } from '../../../shared-gen/Model/Vouchers/Token/TokenSize';
import { OpState }   from "../../../shared-gen/Machine/Status/OpState";

/**
 * API endpoints for debugging functions.
 * These functions do only work if [UIConfig.Debug] is true.
 */
@Injectable({
	providedIn: 'root'
})
export class DebugApi extends HttpService {

	/**
	 * Pays the given amount in cents by the given medium.
	 */
	async payAmount(cents: Cents, medium: Medium): Promise<void> {
		return await this.post<void>(`debug/pay/amount?cents=${cents}&medium=${medium}`);
	}

	/**
	 * Pays a SaniFair voucher.
	 */
	async paySaniFair(): Promise<void> {
		return await this.post<void>('debug/pay/sanifair');
	}

	/**
	 * Pays a token with the given size.
	 */
	async payToken(size: TokenSize): Promise<void> {
		return await this.post<void>(`debug/pay/token?size=${size}`);
	}

	async setDoorState(door: Door, state: DoorState): Promise<void> {
		return await this.post<void>(`debug/door?door=${door}&state=${state}`);
	}

	async setOpState(opState: OpState): Promise<void> {
		return await this.post<void>(`debug/machine/opstate?opstate=${opState}`);
	}

	async setIntervention(): Promise<void> {
		return await this.post<void>("debug/machine/intervention");
	}

}
